import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Stack, Alert, List, ListItem, ListItemText } from '@mui/material';
import { contestAPI } from '../services/api';

const ContestManagement = () => {
  // Singleton mode: manage global submissions only
  const [submissionText, setSubmissionText] = useState('');
  const [listItems, setListItems] = useState([]);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadSubmissions = async () => {
    try {
      setErr(null);
      setLoading(true);
      const res = await contestAPI.listSubmissionsActive();
      setListItems(res.data || []);
    } catch (e) {
      setErr(e?.response?.data?.message || e.message);
      setListItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadSubmissions(); }, []);

  const handleAddSubmission = async () => {
    try {
      setErr(null); setMsg(null);
      const res = await contestAPI.addSubmissionActive(submissionText);
      setMsg(`Додано текст (ID: ${res.data.id})`);
      setSubmissionText('');
      await loadSubmissions();
    } catch (e) {
      setErr(e?.response?.data?.message || e.message);
    }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2, fontWeight: 700 }}>Керування оцінюванням «Студент року»</Typography>
      {msg && <Alert severity="success" sx={{ mb: 2 }}>{msg}</Alert>}
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}

      <Stack spacing={2}>
        <Card>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 1 }}>Додати текст</Typography>
            <Stack spacing={2}>
              <TextField label="Текст" value={submissionText} onChange={(e) => setSubmissionText(e.target.value)} fullWidth multiline minRows={4} />
              <Button variant="contained" onClick={handleAddSubmission} disabled={!submissionText.trim()}>Додати</Button>
            </Stack>
          </CardContent>
        </Card>

        <Card>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="h6">Список текстів</Typography>
              <Button size="small" variant="outlined" onClick={loadSubmissions} disabled={loading}>
                {loading ? 'Оновлення…' : 'Оновити'}
              </Button>
            </Stack>
            <List>
              {listItems.map((s) => (
                <ListItem key={s.id} alignItems="flex-start">
                  <ListItemText primary={`#${s.id}`} secondary={s.text} />
                </ListItem>
              ))}
              {listItems.length === 0 && (
                <Typography variant="body2" color="text.secondary">Немає текстів для відображення</Typography>
              )}
            </List>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
};

export default ContestManagement;
